import DOMPurify from 'dompurify';

const SANITIZE_OPTIONS = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ['target'],
};

// Links that open in a new tab must not hand the opener window to the target.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * Sanitizes HTML authored by other users before it is rendered with
 * dangerouslySetInnerHTML. Returns '' for anything that is not a string.
 */
export function sanitizeHtml(html) {
  if (typeof html !== 'string') {
    return '';
  }
  return DOMPurify.sanitize(html, SANITIZE_OPTIONS);
}
